import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule],
  template: `
    <main class="auth-page">
      <section class="auth-story">
        <img src="assets/perks-logo.svg" alt="PERKS Sports Academy">
        <span>Sports academy operating system</span>
        <h1>Run admissions, guest play, attendance and fees from one SaaS desk.</h1>
        <p>Built for front office teams, coaches and academy admins who need fast daily operations without visual clutter.</p>
      </section>

      <form class="auth-card" [formGroup]="form" (ngSubmit)="submit()">
        <div class="auth-card-header">
          <img src="assets/perks-logo.svg" alt="PERKS Sports Academy">
          <div>
            <h2>Welcome back</h2>
            <p>Sign in to PERKS admin console</p>
          </div>
        </div>

        <label>
          Email
          <input type="email" formControlName="email" autocomplete="username">
        </label>

        <label>
          Password
          <input type="password" formControlName="password" autocomplete="current-password">
        </label>

        @if (error()) {
          <p class="form-error">{{ error() }}</p>
        }

        <button class="primary-action" type="submit" [disabled]="form.invalid || loading()">
          {{ loading() ? 'Signing in...' : 'Sign in' }}
        </button>

        <p class="hint">Demo: superadmin&#64;sportsacademy.local / Admin&#64;123</p>
      </form>
    </main>
  `
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  readonly loading = signal(false);
  readonly error = signal('');
  readonly form = this.fb.nonNullable.group({
    email: ['superadmin@sportsacademy.local', [Validators.required, Validators.email]],
    password: ['Admin@123', Validators.required]
  });

  submit(): void {
    if (this.form.invalid) return;
    this.loading.set(true);
    this.error.set('');
    this.auth.login(this.form.getRawValue()).subscribe({
      next: () => this.router.navigateByUrl('/dashboard'),
      error: () => {
        this.error.set('Login failed. Use demo credentials: superadmin@sportsacademy.local / Admin@123');
        this.loading.set(false);
      }
    });
  }
}
